import React, { SFC, JSX, useState, useEffect, useRef, createRef } from "react";
import withTheme, { PropsType as WithThemeProps } from "../../hoc/withTheme";
import withContentWrap, { PropsType as WithContentWrapProps } from "../../hoc/withContentWrap";
import withVerticalSpacing, { PropsType as WithVerticalSpacingProps } from "../../hoc/withVerticalSpacing";
import "./style.scss";

type PartnerType = {
    id: string;
    name: string;
    text: string;
    src: string;
    srcSet: string;
}
type PropsType = HTMLProps<HTMLDivElement> &
    WithVerticalSpacingProps &
    WithContentWrapProps &
    WithThemeProps & {
        title: string;
        partners: Array<PartnerType>;
    };

const SecondaryPartners: SFC<PropsType> = (props: PropsType): JSX.Element => {
    const [itemsPerRow, setItemsPerRow] = useState(1);
    const [selectedPartner, setSelectedPartner] = useState(-1);
    const contentRefs = useRef<Array<HTMLDivElement>>([]);

    contentRefs.current = props.partners.map((_, index) => contentRefs.current[index] ? contentRefs.current[index] : createRef());

    const checkWidth = () => {
        if (window.innerWidth >= 675 && window.innerWidth < 1023) {
            setItemsPerRow(2)
        } else if (window.innerWidth > 1024) {
            setItemsPerRow(3)
        } else {
            setItemsPerRow(1)
        }
    }

    useEffect(() => {
        checkWidth();
        window.addEventListener('resize', checkWidth);

        return () => window.removeEventListener('resize', checkWidth);
    }, []);

    const isContentRow = (index: number, selectedPartner?: number)  => {
        const count = index;
        const remainder = count % itemsPerRow;
        const rowStart = count - remainder;
        const rowEnd = count - remainder + itemsPerRow - 1;

        console.log('selectedPartner', index, selectedPartner, rowStart);
        console.log('selectedPartner', index, selectedPartner, rowEnd);

        if (selectedPartner > -1) {
            return (remainder === itemsPerRow - 1 || index === props.partners.length - 1) && selectedPartner >= rowStart && selectedPartner <= rowEnd;
        }


        console.log('skip');

        return remainder === itemsPerRow - 1 || index === props.partners.length - 1;
    }

    const contentHeight = contentRefs.current[selectedPartner] ? `${contentRefs.current[selectedPartner].current.clientHeight + 60}px` : '0';

    return (
        <div
            id={props.id}
            className={`SecondaryPartners SecondaryPartners--${props.theme.type} ${selectedPartner > -1 ? 'SecondaryPartners--open' : ''}`}
            style={{ color: props.theme.fill }}
        >
            <div className="SecondaryPartners__wrap">
                {props.partners.map((partner, index) => {
                    return (
                        <>
                            <div 
                                key={`partner-${index}`}
                                className={`SecondaryPartners__partner ${selectedPartner === index ? 'SecondaryPartners__partner--active' : ''}`}
                                onClick={() => { setSelectedPartner(index) }}
                            >
                                <div className="SecondaryPartners__partner-image">
                                    <img src={partner.src} srcSet={partner.srcSet} />
                                </div>
                                <div className="SecondaryPartners__partner-label">{partner.title}</div>
                                <div ref={contentRefs.current[index]} className="SecondaryPartners__partner-content">
                                    <div className="SecondaryPartners__partner-content-inner">
                                        <h2>{partner.title}</h2>
                                        <p>{partner.text}</p>
                                    </div>
                                </div>
                            </div>
                            {isContentRow(index) && (
                                <div key="content" className="SecondaryPartners__content" style={{ height: isContentRow(index, selectedPartner) ? contentHeight : '0' }} />
                            )}
                        </>
                    )
                })}
            </div>
        </div>
    );
};

export default withTheme(withVerticalSpacing(withContentWrap(SecondaryPartners)));
